module.exports = __webpack_public_path__ + "static/media/home15.2fc8c83e.jpg";